import React from "react";
import { Download as DownloadIcon } from "@mui/icons-material";
import {
  Container,
  SidebarContainer,
  Item,
} from "./SidebarAcceptedStyles";
import downloadImages from "../Frames/downloadImages";

const SidebarAccepted = ({ photos, selectedPhotos }) => {
  return (
    <Container>
      <SidebarContainer>
        <Item onClick={() => downloadImages(selectedPhotos, photos)}>
          <DownloadIcon style={{ color: "white" }} />
        </Item>
      </SidebarContainer>
    </Container>
  );
};
export default SidebarAccepted;
